import { useLayoutEffect } from "react";
import { ConnectorService } from '../../base/service/apiServices';
import { LocalStorage } from '../../custom_hooks/localStorageKeys';
import { GetItemFromStorage, SetItemInStorage } from '../../custom_hooks/useStorage';
import Lottie from "lottie-react"; 
import Success from "../../../src/images/Sucess.json";
import { useNavigate } from "react-router-dom";


const ConnectorSuccesspage =  () => {
    const navigate = useNavigate();
const sendToken = async () => {

    let connectorName:any =  GetItemFromStorage('selectedConName');
    const loginUserCcaasDetail = GetItemFromStorage(LocalStorage.USER_DETAILS);
    if(!connectorName || !loginUserCcaasDetail) {
        navigate('/login');
    }

    let windowSearchValue = window.location.search;
    let token = new URLSearchParams(windowSearchValue).get('code');
    let payload = {
        "domainId": loginUserCcaasDetail?.domainId,
        "roleId": '3',
        "connectorName": connectorName,
        "token": token
    };
        await ConnectorService.crmPost(payload).then((data:any)=>{
            if (data.statusCode === 200) {
                // SetItemInStorage(JSON.parse(connectorName) , JSON.stringify(data.results));
                // localStorage.removeItem('selectedConName');

                // setTimeout(() => {
                //     window.close();
                //   }, 2000);   

                setTimeout(() => {
                    if (window.opener) {
                        window.opener.location.reload();
                    }
                    window.close();
                }, 2000);

                //   navigate('/settingspage');
            }
            else {
                console.log("error", data)
            }
        }).catch((err: any) => {
            console.log("err------", err);
        })
}
    useLayoutEffect(() => {
         sendToken();
    }, []);
    
    return (
        <div className="connectorSuccess">
            <Lottie style={{ width: 530, margin: "0 auto" }} animationData={Success} />
            <h3>Connected Successfully</h3>
        </div>
    );
}
 
export default ConnectorSuccesspage;
